// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import Cube from 'cube-ui'
import Vant, { Toast as VantToast } from 'vant'
import 'vant/lib/index.css'
import VueLazyload from 'vue-lazyload'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import pathUtils from './util/pathUtils'
import authorizationUtils from './util/authorizationUtils'

Vue.config.productionTip = false
/* 引入复制功能 */
Vue.use(VueClipboard)
/* 引入cookie工具 */
Vue.use(VueCookies)
/* 引入cube-ui */
Vue.use(Cube)
/* 引入VueLazyload */
Vue.use(VueLazyload)
/* 引入Vant */
Vue.use(Vant)
/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  let requestUrl = config.url
  if (requestUrl && requestUrl.startsWith('/')) {
    config.url = pathUtils.getContextPath(requestUrl)
  }
  return config
})

$axios.interceptors.response.use(response => {
  return response
}, error => {
  Vue.nextTick(() => {
    if (error.response) {
      switch (error.response.status) {
        case 401: {
          store.commit('deleteAccessToken')
          authorizationUtils.toAuthorize(router)
          break
        }
        case 403: {
          Cube.Dialog.$create({
            type: 'confirm',
            title: '禁止访问',
            content: '用户没有访问当前功能的权限，是否重新登录？',
            onConfirm: () => {
              authorizationUtils.toAuthorize(router)
            }
          }).show()
          break
        }
      }
    }
  })
  return Promise.reject(error)
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  let promise
  if (pathUtils.isProtectedUrl(config.url)) {
    promise = new Promise((resolve, reject) => {
      store.dispatch('loadAuthorization').then(token => {
        // 令牌注入
        let headers = config.headers || {}
        headers['Authorization'] = 'bearer ' + token
        config.headers = headers
        $axios(config).then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
      }, err => {
        reject(err)
        authorizationUtils.toAuthorize(router)
      })
    })
  } else {
    promise = $axios(config)
  }
  return promise
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}

Vue.prototype.$toast = function (option) {
  this.$createToast(typeof option === 'string' ? {
    txt: option,
    type: 'txt'
  } : option).show()
}

Vue.prototype.$toastVant = VantToast

Vue.prototype.$loading = function (text) {
  return this.$createToast({
    txt: text || '数据处理中...',
    mask: true,
    time: 0
  }).show()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
